(function() {
  'use strict';

  var Q_KEY = 'mooPackQueue';
  var I_KEY = 'mooPackIndex';
  var T_KEY = 'mooPackTotal';

  // Helper partagé : extrait une quantité numérique depuis item.options OU item.qtyOptions
  function extractQty(item, name) {
    var opts = item.options || [];
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].nom === name) {
        var v = opts[i].valeur;
        if (v == null) return 0;
        var m = String(v).match(/(\d+)/);
        return m ? parseInt(m[1], 10) : 0;
      }
    }
    var qopts = item.qtyOptions || [];
    for (var j = 0; j < qopts.length; j++) {
      if (qopts[j].nom === name) {
        var w = qopts[j].valeur != null ? qopts[j].valeur
              : qopts[j].qty != null ? qopts[j].qty
              : qopts[j].quantite != null ? qopts[j].quantite : 0;
        var n = parseInt(w, 10);
        return isNaN(n) ? 0 : n;
      }
    }
    return 0;
  }

  // ───────────────────────────────────────────────────────────────────────────
  // HOOK FETCH GLOBAL
  // ───────────────────────────────────────────────────────────────────────────
  if (!window._mooFetchHooked) {
    window._mooFetchHooked = true;
    var _origFetch = window.fetch;
    window.fetch = function(url, opts) {
      var isCartAdd = false;
      try {
        if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
          isCartAdd = true;
          if (window._mooExtraProps && opts && opts.body) {
            var props = window._mooExtraProps;
            window._mooExtraProps = null;
            if (opts.body instanceof FormData) {
              Object.keys(props).forEach(function(k) {
                var fullKey = 'properties[' + k + ']';
                if (props[k] === null) {
                  try { opts.body.delete(fullKey); } catch(e) {}
                } else if (props[k] !== undefined && props[k] !== '') {
                  opts.body.set(fullKey, String(props[k]));
                }
              });
            } else if (typeof opts.body === 'string') {
              try {
                var b = JSON.parse(opts.body);
                if (b && typeof b === 'object') {
                  b.properties = b.properties || {};
                  Object.keys(props).forEach(function(k) {
                    if (props[k] === null) {
                      delete b.properties[k];
                    } else if (props[k] !== undefined && props[k] !== '') {
                      b.properties[k] = String(props[k]);
                    }
                  });
                  opts = Object.assign({}, opts, { body: JSON.stringify(b) });
                }
              } catch(e) {}
            }
          }
        }
      } catch(e) {}
      var promise = _origFetch.apply(this, arguments);
      if (isCartAdd) {
        promise.then(function(response) {
          if (response && response.ok) {
            try {
              document.dispatchEvent(new CustomEvent('moo:cart-add-done', { detail: { status: response.status } }));
            } catch(e) {}
          } else if (response) {
            try {
              document.dispatchEvent(new CustomEvent('moo:cart-add-fail', { detail: { status: response.status } }));
            } catch(e) {}
          }
        }).catch(function(err) {
          try {
            document.dispatchEvent(new CustomEvent('moo:cart-add-fail', { detail: { error: String(err) } }));
          } catch(e) {}
        });
      }
      return promise;
    };
  }

  function fmtRouleau(n) { return n + ' rouleau' + (n > 1 ? 'x' : ''); }
  function fmtPiece(n)   { return n + ' pièce'   + (n > 1 ? 's' : ''); }

  // ───────────────────────────────────────────────────────────────────────────
  // Sélecteurs précis : on cible le form PRINCIPAL `/cart/add` (et son submit
  // button) en évitant les form/submit secondaires (popups quickview, blocs
  // "produits similaires", etc.) qui peuvent avoir la même classe
  // `.product_submit_button` mais pointer vers d'autres produits.
  // ───────────────────────────────────────────────────────────────────────────
  function getMainAddForm() {
    // Priorité au form marqué "main-product-form" (Purity theme)
    var f = document.querySelector('form.main-product-form[action*="/cart/add"]');
    if (f) return f;
    // Sinon on tente d'exclure les forms de quickview / popup
    var all = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < all.length; i++) {
      var id = all[i].id || '';
      var sec = all[i].getAttribute('data-section-id') || '';
      // Exclut explicitement les sections quickview / popup / drawer / similar / related
      if (/quickview|popup|drawer|similar|related|recommend/i.test(id + ' ' + sec)) continue;
      return all[i];
    }
    // Fallback ultime : premier form trouvé
    return document.querySelector('form[action*="/cart/add"]');
  }
  function getMainSubmitBtn() {
    var f = getMainAddForm();
    if (f) {
      var b = f.querySelector('.product_submit_button')
           || f.querySelector('button[type="submit"]')
           || f.querySelector('[name="add"]');
      if (b) return b;
    }
    return document.querySelector('.product_submit_button');
  }

  var FIELD_BUILDERS = {
    'plan-de-travail-sur-mesure': function(item) {
      var get = function(name) { for (var i = 0; i < (item.options || []).length; i++) if (item.options[i].nom === name) return item.options[i].valeur; return ''; };
      var rQty = extractQty(item, 'Bande de chant en rouleau 1m');
      var aLDQty = extractQty(item, 'Assemblage linéaire droit');
      var aLGQty = extractQty(item, 'Assemblage linéaire gauche');
      var aADQty = extractQty(item, "Assemblage d'angle droit");
      var aAGQty = extractQty(item, "Assemblage d'angle gauche");
      var cPQty = extractQty(item, 'Pan coupé');
      var cQQty = extractQty(item, '1/4 de rond');
      var cAQty = extractQty(item, 'Arc de cercle');
      var cQIQty = extractQty(item, '1/4 de rond intérieur');
      var cPaQty = extractQty(item, 'Pan avancé');
      var decor2 = get('Finition décor 2 faces');
      var props = {};
      if (decor2 && decor2.indexOf('Oui') === 0) props['Décor 2 faces'] = decor2;
      if (rQty > 0) props['Bande rouleau'] = fmtRouleau(rQty);
      if (aLDQty > 0) props['Assemblage linéaire droit'] = fmtPiece(aLDQty);
      if (aLGQty > 0) props['Assemblage linéaire gauche'] = fmtPiece(aLGQty);
      if (aADQty > 0) props["Assemblage d'angle droit"] = fmtPiece(aADQty);
      if (aAGQty > 0) props["Assemblage d'angle gauche"] = fmtPiece(aAGQty);
      if (cPQty > 0) props['Pan coupé'] = fmtPiece(cPQty);
      if (cQQty > 0) props['1/4 de rond'] = fmtPiece(cQQty);
      if (cAQty > 0) props['Arc de cercle'] = fmtPiece(cAQty);
      if (cQIQty > 0) props['1/4 de rond intérieur'] = fmtPiece(cQIQty);
      if (cPaQty > 0) props['Pan avancé'] = fmtPiece(cPaQty);
      return {
        field_1: parseFloat(item.price).toFixed(2),
        field_2: item.largeur + 'mm x ' + item.longueur + 'mm',
        field_3: get('Épaisseur') || '38mm',
        field_4: get('Ajout de chant') || 'Chant avant uniquement',
        _extraProps: props
      };
    },
    'plan-de-travail-sur-mesure-pour-ilot': function(item) {
      var get = function(name) { for (var i = 0; i < (item.options || []).length; i++) if (item.options[i].nom === name) return item.options[i].valeur; return ''; };
      var rQty = extractQty(item, 'Bande de chant en rouleau 1m');
      var aLDQty = extractQty(item, 'Assemblage linéaire droit');
      var aLGQty = extractQty(item, 'Assemblage linéaire gauche');
      var aADQty = extractQty(item, "Assemblage d'angle droit");
      var aAGQty = extractQty(item, "Assemblage d'angle gauche");
      var cPQty = extractQty(item, 'Pan coupé');
      var cQQty = extractQty(item, '1/4 de rond');
      var cAQty = extractQty(item, 'Arc de cercle');
      var cQIQty = extractQty(item, '1/4 de rond intérieur');
      var cPaQty = extractQty(item, 'Pan avancé');
      var decor2 = get('Finition décor 2 faces');
      var props = {};
      if (decor2 && decor2.indexOf('Oui') === 0) props['Décor 2 faces'] = decor2;
      if (rQty > 0) props['Bande rouleau'] = fmtRouleau(rQty);
      if (aLDQty > 0) props['Assemblage linéaire droit'] = fmtPiece(aLDQty);
      if (aLGQty > 0) props['Assemblage linéaire gauche'] = fmtPiece(aLGQty);
      if (aADQty > 0) props["Assemblage d'angle droit"] = fmtPiece(aADQty);
      if (aAGQty > 0) props["Assemblage d'angle gauche"] = fmtPiece(aAGQty);
      if (cPQty > 0) props['Pan coupé'] = fmtPiece(cPQty);
      if (cQQty > 0) props['1/4 de rond'] = fmtPiece(cQQty);
      if (cAQty > 0) props['Arc de cercle'] = fmtPiece(cAQty);
      if (cQIQty > 0) props['1/4 de rond intérieur'] = fmtPiece(cQIQty);
      if (cPaQty > 0) props['Pan avancé'] = fmtPiece(cPaQty);
      return {
        field_1: parseFloat(item.price).toFixed(2),
        field_2: item.largeur + 'mm x ' + item.longueur + 'mm',
        field_3: get('Épaisseur') || '38mm',
        field_4: get('Ajout de chant') || 'Chant avant uniquement',
        _extraProps: props
      };
    },
    // ─── Crédence simple (Custom Liquid native, comme la GG) ───────────────
    // Inputs : moo-width / moo-length / radios moo-chant (3 valeurs)
    // Pas de bouton "rouleau +" sur cette page (vérifié via console : aucun
    // bouton moo-rouleau-* présent), donc on n'envoie pas de _clicks.
    'credence-surmesure': function(item) {
      var get = function(name) { for (var i = 0; i < (item.options || []).length; i++) if (item.options[i].nom === name) return item.options[i].valeur; return ''; };
      var chant = get('Ajout de chant') || 'Chant dessus uniquement';
      var rQty = extractQty(item, 'Bande de chant en rouleau 1m');
      // 3 radios moo-chant : index 0 = dessus, 1 = +1 côté, 2 = +2 côtés
      var chantIdx = 0;
      if (chant.indexOf('1 côté') > -1 || chant.indexOf('1 cote') > -1) chantIdx = 1;
      else if (chant.indexOf('2 côtés') > -1 || chant.indexOf('2 cotes') > -1) chantIdx = 2;
      var props = {
        'Épaisseur': '9mm',
        'Chant': chant
      };
      if (rQty > 0) props['Bande rouleau'] = fmtRouleau(rQty);
      return {
        _native: true,
        _inputs: {
          'moo-width': String(item.largeur || ''),
          'moo-length': String(item.longueur || '')
        },
        _radios: [{ name: 'moo-chant', index: chantIdx }],
        _extraProps: props
      };
    },
    'plinthe-sur-mesure': function(item) {
      var get = function(name) { for (var i = 0; i < (item.options || []).length; i++) if (item.options[i].nom === name) return item.options[i].valeur; return ''; };
      var couleur = get('Couleur');
      var props = { 'Prix TTC': null };
      if (couleur) props['Couleur'] = couleur;
      return {
        field_1: parseFloat(item.price).toFixed(2),
        field_2: 'Plinthe ' + (item.longueur || '') + 'mm x ' + (item.largeur || '') + 'mm',
        _extraProps: props
      };
    },
    // ─── Étagère sur mesure (Custom Liquid native) ─────────────────────────
    // - Supprime "Prix TTC" (doublon avec prix de ligne) si présent
    // - Ajoute "Couleur" (lue depuis options envoyées par le configurateur,
    //   même fonction que la plinthe → couleur déjà incluse)
    'etagere-sur-mesure': function(item) {
      var get = function(name) { for (var i = 0; i < (item.options || []).length; i++) if (item.options[i].nom === name) return item.options[i].valeur; return ''; };
      var couleur = get('Couleur');
      var props = { 'Prix TTC': null };
      if (couleur) props['Couleur'] = couleur;
      return {
        _native: true,
        _inputs: {
          'moo-et-h': String(item.longueur || ''),
          'moo-et-l': String(item.largeur || '')
        },
        _extraProps: props
      };
    },
    'credence-sur-mesure-grand-gabarit': function(item) {
      var get = function(name) { for (var i = 0; i < (item.options || []).length; i++) if (item.options[i].nom === name) return item.options[i].valeur; return ''; };
      var chantLabel = get('Ajout de chant') || 'Chant dessus uniquement';
      var chantIdx = 0;
      if (chantLabel.indexOf('gauche') > -1) chantIdx = 1;
      else if (chantLabel.indexOf('droite') > -1) chantIdx = 2;
      else if (chantLabel.indexOf('2 côtés') > -1 || chantLabel.indexOf('2 cotes') > -1) chantIdx = 3;
      var rouleauVal = get('Bande de chant en rouleau 1m') || '';
      var rouleauQty = 0;
      var rouleauMatch = rouleauVal.match(/(\d+)/);
      if (rouleauMatch) rouleauQty = parseInt(rouleauMatch[1], 10);
      var props = {
        'Épaisseur': '9mm',
        'Chant': chantLabel
      };
      if (rouleauQty > 0) props['Bande rouleau'] = fmtRouleau(rouleauQty);
      return {
        _native: true,
        _inputs: {
          'moo-width': String(item.largeur || ''),
          'moo-length': String(item.longueur || '')
        },
        _radios: [{ name: 'moo-chant', index: chantIdx }],
        _clicks: [{ id: 'moo-rouleau-plus', count: rouleauQty }],
        _extraProps: props
      };
    },
    'facade-joue-fileur-plinthe-sur-mesure': function(item) {
      var get = function(name) { for (var i = 0; i < (item.options || []).length; i++) if (item.options[i].nom === name) return item.options[i].valeur; return ''; };
      var typeOpt = get('Type');
      var couleur = get('Couleur');
      var poignee = get('Poignée');
      var prefix = typeOpt || 'Façade';
      var props = { 'Prix TTC': null };
      if (couleur) props['Couleur'] = couleur;
      if (poignee) props['Poignée'] = poignee;
      return {
        field_1: parseFloat(item.price).toFixed(2),
        field_2: prefix + ' ' + (item.longueur || '') + 'mm x ' + (item.largeur || '') + 'mm',
        _extraProps: props
      };
    },
    'caisson-sur-mesure': function(item) {
      var get = function(name) { for (var i = 0; i < (item.options || []).length; i++) if (item.options[i].nom === name) return item.options[i].valeur; return ''; };
      var prof = '';
      var dimsRaw = get('Dimensions');
      var m = dimsRaw.match(/P=(\d+)mm/);
      if (m) prof = m[1];
      var typeOpt        = get('Type');
      var config         = get('Configuration');
      var couleur        = get('Couleur');
      var couleurCaisson = get('Couleur caisson');
      var poignee        = get('Poignée');
      var modeleRef      = get('Modèle de référence');
      var props = { 'Prix TTC': null };
      if (typeOpt)        props['Type']                = typeOpt;
      if (config)         props['Configuration']       = config;
      if (couleur)        props['Couleur']             = couleur;
      if (couleurCaisson) props['Couleur caisson']     = couleurCaisson;
      if (poignee)        props['Poignée']             = poignee;
      if (modeleRef)      props['Modèle de référence'] = modeleRef;
      return {
        field_1: parseFloat(item.price).toFixed(2),
        field_2: 'L=' + (item.largeur || '') + 'mm H=' + (item.longueur || '') + 'mm P=' + prof + 'mm',
        _extraProps: props
      };
    },
    'niche-sur-mesure': function(item) {
      var get = function(name) { for (var i = 0; i < (item.options || []).length; i++) if (item.options[i].nom === name) return item.options[i].valeur; return ''; };
      function clean(s) { return (s || '').replace(/\s*mm\s*/g,'').replace(/\s*×\s*/g,' × ').trim(); }
      var H = item.longueur || '';
      var L = item.largeur || '';
      var P = '';
      var dimsGlobales = get('Dimensions globales');
      var partsP = dimsGlobales.match(/(\d+)\s*×\s*(\d+)\s*×\s*(\d+)/);
      if (partsP) P = partsP[3];
      var couleur  = get('Couleur');
      var finition = get('Finition');
      var joues    = clean(get('2 joues (cotes usine)'));
      var tablett  = clean(get('2 tablettes (cotes usine)'));
      var fond     = clean(get('1 fond (cotes usine)'));
      var props = { 'Prix TTC': null };
      if (couleur)  props['Couleur']        = couleur;
      if (finition) props['Finition']       = finition;
      if (joues)    props['Joues (×2)']     = joues + ' mm';
      if (tablett)  props['Tablettes (×2)'] = tablett + ' mm';
      if (fond)     props['Fond (×1)']      = fond + ' mm';
      return {
        field_1: parseFloat(item.price).toFixed(2),
        field_2: 'H=' + H + 'mm × L=' + L + 'mm × P=' + P + 'mm',
        _extraProps: props
      };
    },
    'porte-derobee-sur-mesure': function(item) {
      var get = function(name) { for (var i = 0; i < (item.options || []).length; i++) if (item.options[i].nom === name) return item.options[i].valeur; return ''; };
      var sens = get("Sens d'ouverture") || 'Gauche';
      var poignee = get('Poignée') || 'Avec poignée';
      var finition = get('Finition') || '';
      var couleur = get('Couleur') || '';
      var dimsPorte = get('Porte (dimensions)') || '';
      var dimsMG = get('Montant gauche (dimensions)') || '';
      var dimsMD = get('Montant droit (dimensions)') || '';
      var dimsTR = get('Traverse haute (dimensions)') || '';
      var dimsPL = get('Plinthe (dimensions)') || '';
      var porteMatch = dimsPorte.match(/(\d+)\s*x\s*(\d+)/);
      var porteH = porteMatch ? porteMatch[1] : '';
      var porteL = porteMatch ? porteMatch[2] : '';
      var props = {
        "Sens d'ouverture": sens,
        "Poignée": 'Poignée : ' + poignee,
        "Finition": 'Finition : ' + finition,
        "Couleur": 'Couleur : ' + couleur,
        "Porte (dimensions)": 'Porte : ' + dimsPorte,
        "Montant gauche (dimensions)": 'Montant gauche : ' + dimsMG,
        "Montant droit (dimensions)": 'Montant droit : ' + dimsMD,
        "Traverse haute (dimensions)": 'Traverse haute : ' + dimsTR,
        "Plinthe (dimensions)": 'Plinthe : ' + dimsPL
      };
      return {
        field_1: parseFloat(item.price).toFixed(2),
        field_2: 'Porte dérobée ' + sens.toLowerCase() + ' ' + porteH + 'x' + porteL + 'mm',
        _extraProps: props
      };
    },
    'colonne-lave-vaisselle-sur-mesure': function(item) {
  var get = function(name) { for (var i = 0; i < (item.options || []).length; i++) if (item.options[i].nom === name) return item.options[i].valeur; return ''; };
  function getMm(key) {
    var m = (get(key) || '').match(/(\d+)/);
    return m ? m[1] : '';
  }
  var hPlancher = getMm('Hauteur plancher LV');
  var ht        = getMm('Hauteur totale colonne');
  var pc        = getMm('Profondeur colonne');
  var props = {};
  (item.options || []).forEach(function(o) {
    if (o.nom && o.valeur) props[o.nom] = o.valeur;
  });
  return {
    field_1: parseFloat(item.price).toFixed(2),
    field_2: 'Colonne LV ' + ht + 'x' + pc + 'mm, plancher LV à ' + hPlancher + 'mm',
    _extraProps: props
  };
}
,
'niche-refrigerateur-sur-mesure': function(item) {
  var get = function(name) { for (var i = 0; i < (item.options || []).length; i++) if (item.options[i].nom === name) return item.options[i].valeur; return ''; };
  var dimsFrigo = get('Dimensions frigo');
  var props = {};
  (item.options || []).forEach(function(o) {
    if (o.nom && o.valeur) props[o.nom] = o.valeur;
  });
  return {
    field_1: parseFloat(item.price).toFixed(2),
    field_2: 'Niche réfrigérateur (frigo ' + (dimsFrigo || '-') + ')',
    _extraProps: props
  };
}
  };

  window.mooPackBuildUrl = function(item, idx, total) {
    var params = new URLSearchParams();
    params.set('variant', String(item.variantId));
    params.set('moo_sm_chain', '1');
    params.set('moo_sm_idx', String(idx + 1));
    params.set('moo_sm_total', String(total));
    return '/products/' + item.handle + '?' + params.toString();
  };

  function buildNextStepUrl() {
    try {
      var queue = JSON.parse(sessionStorage.getItem(Q_KEY) || '[]');
      var idx = parseInt(sessionStorage.getItem(I_KEY) || '0', 10);
      var total = parseInt(sessionStorage.getItem(T_KEY) || '0', 10);
      var nextIdx = idx + 1;
      if (nextIdx >= queue.length) return '/cart?mooPackDone=1';
      sessionStorage.setItem(I_KEY, String(nextIdx));
      return window.mooPackBuildUrl(queue[nextIdx], nextIdx, total);
    } catch(e) { return '/cart'; }
  }

  // ─── Overlay animé pendant la chaîne d'ajout ──────────────────────────────
  // Style Genz : vibe complice, micro-messages qui tournent, progress bar
  // smooth, icône produit, anim douce. Pas de feu d'artifice cheap.
  var MOO_HANDLE_META = {
    'plan-de-travail-sur-mesure':              { emoji: '🪵', label: 'Plan de travail' },
    'plan-de-travail-sur-mesure-pour-ilot':    { emoji: '🪵', label: 'Plan de travail îlot' },
    'credence-surmesure':                      { emoji: '🧱', label: 'Crédence' },
    'credence-sur-mesure-grand-gabarit':       { emoji: '🧱', label: 'Crédence XXL' },
    'plinthe-sur-mesure':                      { emoji: '📏', label: 'Plinthe' },
    'etagere-sur-mesure':                      { emoji: '🪞', label: 'Étagère' },
    'facade-joue-fileur-plinthe-sur-mesure':   { emoji: '🚪', label: 'Façade' },
    'caisson-sur-mesure':                      { emoji: '🧰', label: 'Caisson' },
    'niche-sur-mesure':                        { emoji: '🛖', label: 'Niche' },
    'porte-derobee-sur-mesure':                { emoji: '🚪', label: 'Porte dérobée' },
    'colonne-lave-vaisselle-sur-mesure':       { emoji: '🍽️', label: 'Colonne lave-vaisselle' },
    'niche-refrigerateur-sur-mesure':          { emoji: '❄️', label: 'Niche réfrigérateur' }
  };
  var MOO_VIBES = [
    'on assemble ton pack ✨',
    'ça check les côtes au mm près',
    'la team prend des notes',
    'on met le pack au four 🔥',
    'no stress, on gère',
    'la cuisine se dessine',
    'petite minute, grand projet',
    'on plie les détails',
    'le four chauffe à 220°',
    'on fait du joli',
    'attends, c\'est presque cuit',
    'on fignole les finitions',
    'tout est sous contrôle',
    'on serre les vis (au sens figuré)',
    'la magie opère ✨',
    'le sur-mesure, ça prend 2 min'
  ];

  function getCurrentItemMeta() {
    try {
      var queue = JSON.parse(sessionStorage.getItem(Q_KEY) || '[]');
      var qidx = parseInt(sessionStorage.getItem(I_KEY) || '0', 10);
      var item = queue[qidx];
      if (!item) return null;
      return MOO_HANDLE_META[item.handle] || { emoji: '📦', label: item.handle };
    } catch(e) { return null; }
  }

  function showOverlay(idx, total) {
    if (document.getElementById('mooPackOverlay')) return;
    var meta = getCurrentItemMeta() || { emoji: '📦', label: '' };
    var idxN = parseInt(idx, 10) || 1;
    var totalN = parseInt(total, 10) || 1;
    var pct = Math.max(8, Math.round((idxN - 0.5) / totalN * 100));

    var st = document.createElement('style');
    st.textContent = ''
      + '@keyframes mooSpin{to{transform:rotate(360deg)}}'
      + '@keyframes mooBob{0%,100%{transform:translateY(0)}50%{transform:translateY(-8px)}}'
      + '@keyframes mooPulse{0%,100%{transform:scale(1);opacity:.7}50%{transform:scale(1.1);opacity:1}}'
      + '@keyframes mooFadeUp{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}'
      + '@keyframes mooBarShine{0%{transform:translateX(-100%)}100%{transform:translateX(300%)}}'
      + '@keyframes mooDot{0%,80%,100%{opacity:.3}40%{opacity:1}}'
      + '@keyframes mooGradientShift{0%,100%{background-position:0% 50%}50%{background-position:100% 50%}}'
      + '.moo-vibe{animation:mooFadeUp .35s ease-out}'
      + '.moo-emoji{display:inline-block;animation:mooBob 1.6s ease-in-out infinite}'
      + '.moo-dot{animation:mooDot 1.4s infinite}'
      + '.moo-dot:nth-child(2){animation-delay:.2s}'
      + '.moo-dot:nth-child(3){animation-delay:.4s}';
    document.head.appendChild(st);

    var ov = document.createElement('div');
    ov.id = 'mooPackOverlay';
    ov.style.cssText = ''
      + 'position:fixed;inset:0;z-index:99999;'
      + 'background:linear-gradient(135deg,#fff8ed 0%,#fff3e4 50%,#ffeacc 100%);'
      + 'background-size:200% 200%;animation:mooGradientShift 8s ease infinite;'
      + 'display:flex;flex-direction:column;align-items:center;justify-content:center;'
      + 'gap:0;font-family:Inter,-apple-system,system-ui,sans-serif;color:#12312b;padding:24px;';

    ov.innerHTML = ''
      // Compteur géant n/total
      + '<div style="font-family:Caveat,cursive;font-size:18px;color:#6f7f7b;letter-spacing:.05em;margin-bottom:4px;">on prépare ton pack</div>'
      + '<div style="display:flex;align-items:baseline;gap:6px;font-weight:900;line-height:1;margin-bottom:28px;">'
      +   '<span id="mooCountIdx" style="font-size:88px;color:#12312b;font-feature-settings:\'tnum\';">' + idxN + '</span>'
      +   '<span style="font-size:34px;color:#C4622A;font-weight:700;">/' + totalN + '</span>'
      + '</div>'
      // Carte produit en cours
      + '<div style="background:#fff;border:1.5px solid #12312b;border-radius:18px;box-shadow:5px 5px 0 0 #DFAE3A;padding:18px 22px;display:flex;align-items:center;gap:14px;min-width:280px;max-width:90vw;margin-bottom:22px;animation:mooFadeUp .4s ease-out;">'
      +   '<div style="font-size:36px;line-height:1;flex-shrink:0;" class="moo-emoji">' + meta.emoji + '</div>'
      +   '<div style="flex:1;min-width:0;">'
      +     '<div style="font-size:11px;color:#9ca3af;text-transform:uppercase;letter-spacing:.08em;font-weight:700;margin-bottom:2px;">en cours</div>'
      +     '<div style="font-size:17px;font-weight:700;color:#12312b;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + meta.label + '</div>'
      +   '</div>'
      + '</div>'
      // Progress bar
      + '<div style="width:min(420px,90vw);height:10px;background:#fff;border:1.5px solid #12312b;border-radius:60px;overflow:hidden;position:relative;margin-bottom:18px;">'
      +   '<div id="mooBar" style="height:100%;background:linear-gradient(90deg,#0f3f37,#174E44,#C4622A);width:' + pct + '%;border-radius:60px;transition:width .6s cubic-bezier(.2,.9,.3,1);position:relative;overflow:hidden;">'
      +     '<div style="position:absolute;inset:0;background:linear-gradient(90deg,transparent,rgba(255,255,255,.5),transparent);width:40%;animation:mooBarShine 1.8s ease-in-out infinite;"></div>'
      +   '</div>'
      + '</div>'
      // Vibe message qui change
      + '<div id="mooVibe" class="moo-vibe" style="font-family:Caveat,cursive;font-size:24px;color:#12312b;text-align:center;margin-bottom:8px;min-height:32px;">' + MOO_VIBES[Math.floor(Math.random()*MOO_VIBES.length)] + '</div>'
      // Dots animées
      + '<div style="display:flex;gap:6px;align-items:center;color:#6f7f7b;font-size:12px;font-weight:600;letter-spacing:.05em;">'
      +   '<span class="moo-dot">●</span><span class="moo-dot">●</span><span class="moo-dot">●</span>'
      +   '<span style="margin-left:8px;">ferme pas l\'onglet</span>'
      + '</div>';

    document.body.appendChild(ov);

    // Rotation du message vibe toutes les 2,2s
    var lastVibe = -1;
    setInterval(function() {
      var vibeEl = document.getElementById('mooVibe');
      if (!vibeEl) return;
      var i;
      do { i = Math.floor(Math.random() * MOO_VIBES.length); } while (i === lastVibe && MOO_VIBES.length > 1);
      lastVibe = i;
      vibeEl.style.animation = 'none';
      vibeEl.offsetHeight; // force reflow
      vibeEl.style.animation = 'mooFadeUp .35s ease-out';
      vibeEl.textContent = MOO_VIBES[i];
    }, 2200);
  }

  // Sélecteur précis : on cherche l'input field_X DANS la zone OPC liée au
  // form principal en priorité, pour éviter de tomber sur l'OPC d'une carte
  // produit secondaire (similaires/recommandés).
  function field(name) {
    var mainForm = getMainAddForm();
    if (mainForm) {
      // Cherche aussi à proximité : OPC peut être dans un container voisin
      var section = mainForm.closest('section, .product, .product-detail, .product-detail__information, body');
      if (section) {
        var f = section.querySelector('[data-name="' + name + '"] input[name="' + name + '"]')
             || section.querySelector('input[name="' + name + '"]');
        if (f) return f;
      }
    }
    return document.querySelector('[data-name="' + name + '"] input[name="' + name + '"]')
        || document.querySelector('input[name="' + name + '"]');
  }
  function setField(el, val) {
    if (!el) return;
    el.value = String(val);
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function autoSubmit(item) {
    var builder = FIELD_BUILDERS[item.handle];
    if (!builder) {
      console.warn('moo-pack-chain: handle non supporté :', item.handle);
      window.location.href = buildNextStepUrl();
      return;
    }
    var fields = builder(item);
    var isCustom = fields._custom === true;
    var isNative = fields._native === true;
    var nativeInputs = fields._inputs || {};
    var nativeRadios = fields._radios || [];
    var nativeClicks = fields._clicks || [];
    var extraProps   = fields._extraProps || null;
    if (isCustom) delete fields._custom;
    if (isNative) { delete fields._native; delete fields._inputs; delete fields._radios; delete fields._clicks; }
    delete fields._extraProps;

    var nativeClicksDone = false;
    function fillNativeInputs() {
      for (var inputId in nativeInputs) {
        var el = document.getElementById(inputId);
        if (el) {
          el.value = nativeInputs[inputId];
          el.dispatchEvent(new Event('input', { bubbles: true }));
          el.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      nativeRadios.forEach(function(r) {
        var radios = document.querySelectorAll('input[type="radio"][name="' + r.name + '"]');
        if (radios[r.index]) {
          radios[r.index].checked = true;
          radios[r.index].click();
          radios[r.index].dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      if (!nativeClicksDone) {
        nativeClicks.forEach(function(c) {
          var btn = document.getElementById(c.id);
          if (btn) {
            for (var n = 0; n < c.count; n++) btn.click();
          }
        });
        nativeClicksDone = true;
      }
    }

    var initialCount = 0;
    var initialCountResolved = false;
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      initialCount = (c.items || []).reduce(function(s, it){ return s + it.quantity; }, 0);
      initialCountResolved = true;
    }).catch(function(){ initialCountResolved = true; });

    function injectCustomProperties() {
      var form = getMainAddForm();
      if (!form) return false;
      for (var k in fields) {
        var existing = form.querySelector('input[name="' + k.replace(/"/g, '\\"') + '"]');
        if (existing) {
          existing.value = String(fields[k]);
        } else {
          var inp = document.createElement('input');
          inp.type = 'hidden';
          inp.name = k;
          inp.value = String(fields[k]);
          form.appendChild(inp);
        }
      }
      var priceCents = Math.round(parseFloat(fields['properties[Prix TTC]']) * 100);
      var ooPrice = form.querySelector('input[name="properties[__ooCustomPrice]"]');
      if (ooPrice) ooPrice.value = String(priceCents);
      return true;
    }

    var attempts = 0;
    var iv = setInterval(function() {
      attempts++;
      if (isNative) {
        fillNativeInputs();
      } else if (isCustom) {
        injectCustomProperties();
      } else {
        for (var k in fields) { var f = field(k); if (f) setField(f, fields[k]); }
      }
      // ⇩ FIX BUG CREDENCE : on cible précisément le bouton du form principal
      // (pas n'importe quel .product_submit_button du DOM, qui pourrait
      // appartenir à une popup quickview ou bloc "produits similaires").
      var btn = getMainSubmitBtn();
      if (btn) {
        clearInterval(iv);
        setTimeout(function() {
          if (isNative) fillNativeInputs();
          else if (isCustom) injectCustomProperties();
          else for (var k in fields) { var f = field(k); if (f) setField(f, fields[k]); }
          setTimeout(function() {
            if (isNative) fillNativeInputs();
            else if (isCustom) injectCustomProperties();
            else for (var k in fields) { var f = field(k); if (f) setField(f, fields[k]); }
            if (extraProps && Object.keys(extraProps).length > 0) {
              window._mooExtraProps = extraProps;
            }

            var nextUrl = buildNextStepUrl();
            var redirected = false;
            var pIv = null;
            var safetyTimer = null;

            function doRedirect(reason) {
              if (redirected) return;
              redirected = true;
              if (pIv) { clearInterval(pIv); pIv = null; }
              if (safetyTimer) { clearTimeout(safetyTimer); safetyTimer = null; }
              document.removeEventListener('moo:cart-add-done', onCartDone);
              document.removeEventListener('moo:cart-add-fail', onCartFail);
              window.location.href = nextUrl;
            }
            function onCartDone() {
              setTimeout(function() { doRedirect('cart-add-done'); }, 250);
            }
            function onCartFail(e) {
              console.warn('moo-pack: /cart/add a échoué', e && e.detail);
              setTimeout(function() { doRedirect('cart-add-fail'); }, 500);
            }
            document.addEventListener('moo:cart-add-done', onCartDone);
            document.addEventListener('moo:cart-add-fail', onCartFail);

            try { btn.click(); } catch(e) { console.error('moo-pack click error', e); }

            var pAttempts = 0;
            pIv = setInterval(function() {
              pAttempts++;
              fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
                var newCount = (c.items || []).reduce(function(s, it){ return s + it.quantity; }, 0);
                if (initialCountResolved && newCount > initialCount) {
                  doRedirect('poll-count');
                } else if (pAttempts > 60) {
                  console.warn('moo-pack: panier non détecté après 30s, redirect quand même');
                  doRedirect('poll-timeout');
                }
              }).catch(function(){
                if (pAttempts > 60) doRedirect('poll-error');
              });
            }, 500);

            safetyTimer = setTimeout(function() {
              console.warn('moo-pack: filet de sécurité 60s déclenché, redirect forcé');
              doRedirect('safety-60s');
            }, 60000);
          }, 700);
        }, 500);
      }
      if (attempts > 60) { clearInterval(iv); console.error('moo-pack: bouton OPC introuvable'); window.location.href = buildNextStepUrl(); }
    }, 200);
  }

  document.addEventListener('DOMContentLoaded', function() {
    var p = new URLSearchParams(window.location.search);
    var path = window.location.pathname;

    if (path === '/cart' && p.get('mooPackDone') === '1') {
      sessionStorage.removeItem(Q_KEY);
      sessionStorage.removeItem(I_KEY);
      sessionStorage.removeItem(T_KEY);
      var u = new URL(window.location.href);
      u.searchParams.delete('mooPackDone');
      window.history.replaceState({}, '', u.pathname + (u.search ? u.search : ''));
      return;
    }

    if (p.get('moo_sm_chain') === '1') {
      var idx = p.get('moo_sm_idx') || '?';
      var total = p.get('moo_sm_total') || '?';
      showOverlay(idx, total);
      var queue, qidx;
      try {
        queue = JSON.parse(sessionStorage.getItem(Q_KEY) || '[]');
        qidx = parseInt(sessionStorage.getItem(I_KEY) || '0', 10);
      } catch(e) { window.location.href = '/cart'; return; }
      var item = queue[qidx];
      if (!item) {
        sessionStorage.removeItem(Q_KEY); sessionStorage.removeItem(I_KEY); sessionStorage.removeItem(T_KEY);
        window.location.href = '/cart'; return;
      }
      autoSubmit(item);
    }
  });
})();
